import fetchServer from "../../../fetchServer";

function parseVoidResponse(res, fallbackMsg) {
  if (!res) {
    return { return: 0, msg: fallbackMsg, data: [], code: null };
  }

  const payload = res.data ?? res;
  const nested =
    payload?.data && typeof payload.data === "object" ? payload.data : payload;
  const httpOk = res.status >= 200 && res.status < 300;

  if (httpOk) {
    return {
      return: 1,
      msg: payload?.message || "Successfull",
      data: payload?.data ?? payload,
      code: null,
    };
  }

  return {
    return: 0,
    msg: nested?.error || payload?.error || payload?.message || fallbackMsg,
    data: nested || [],
    code: nested?.code ?? payload?.code ?? null,
  };
}

export default async function manualVoid(id) {
  var result = {
    return: 0,
    msg: "Failed updating flight",
    data: [],
    code: null,
  };

  await fetchServer({
    method: "POST",
    url: `/product/v1/voidTicket/manualVoid/${id}`,
  })
    .then((res) => {
      result = parseVoidResponse(res, result.msg);
    })
    .catch((err) => {
      console.log(err.message, err);
      if (err.message === "Network Error!") {
        result["msg"] = "Network Error!";
        result["error"] = "Please check your connection.";
      }
    });

  return result;
}
